// Helper for linking to pieces of content
import { APP_MAPPING_BY_SLUG } from '../../../config'

function linkToProgramUnit(programUnitSlug, programSlug, activeHubSlug) {
  if (!activeHubSlug) {
    return null
  }

  const appMapping = APP_MAPPING_BY_SLUG[activeHubSlug]
  return  '/' + activeHubSlug + '/' + appMapping.route + '/' + programSlug + '/pages/' + programUnitSlug
}

export default linkToProgramUnit
